// Superadmins, and admins outside MML. Mirrors requireNonMmlAdmin on the
// API, which is the real control; this only decides what the UI shows.
export const isNonMmlAdmin = (user) => Boolean(user
    && (user.role === 'superadmin' || (user.role === 'admin' && user.source !== 'mml')));
